<template>
  <div class="my-navbar">
    <transition name="fade">
      <div v-if="collapsed" class="aalign-center my-navbar__logos">
        <img src="/img/logos/alfathedulogo-small.png" alt="" class="mr-4" />
        <img
          src="/img/icons/menu.svg"
          alt=""
          class="c-pointer"
          @click="$emit('menuClick')"
        />
      </div>
    </transition>

    <div class="my-navbar__right sm-hide">
      <a class="mr-2" :href="'https://alfathbelajar.com/subject' + (section.subject_id ? ('/'+section.subject_id) : '')"  v-if="checkPage">
        <my-button>
          <fa-icon icon="home" class="mr-1"></fa-icon>
          Course Detail
        </my-button>
      </a>

      <a class="mr-2" :href="'https://alfathbelajar.com/tryoutlist'" v-if="tryoutPage">
        <my-button>
          <fa-icon icon="home" class="mr-1"></fa-icon>
          Back To Tryout
        </my-button>
      </a>

      <my-button v-if="tryoutPage" @click="goToTryoutHistory">
        <fa-icon icon="clock" class="mr-1"></fa-icon>
        Tryout History
      </my-button>

      <!-- <my-button class="mr-2" v-show="isLoggedIn">
        <fa-icon :icon="['far', 'star']" class="mr-1"></fa-icon>
        Beri Rating
      </my-button> -->
      
      <my-button class="mr-2" type="fill-blue" v-if="isLoggedIn && checkPage" @click="goToForum">
        <fa-icon icon="comment-dots" class="mr-1"></fa-icon> Forum
      </my-button>

      <b-dropdown text="Notification" class="my-dropdown mr-2" v-if="checkPage">
        <template #button-content>
          <fa-icon icon="bell" class="mr-1"></fa-icon> 
          <b-badge pill variant="danger" v-if="unread">{{unread}}</b-badge>
        </template>
        <b-dropdown-item @click="goToNotif()" class="text-center">
          <a href="#">See All Notification</a>
        </b-dropdown-item>
        <b-dropdown-item v-for="(itm, idx) in notifs" @click="goToForumDetail(itm)" :key="'a-'+idx">
          <div class="aspace-between mb-2">
            <img src="/img/avatars/user-avatar4.png" alt="avatar" width="30"/>
            <span class="discussion__time">
              <b>{{ itm.user_name }}</b>
            </span>
            <span class="discussion__time">
              {{ $helpers.formatDateTimeID(itm.created_at) }}
            </span>
          </div>
          <div v-if="itm.type=='forum_reply'">
            <a href="#">{{ itm.user_name }}</a> 
            menjawab pertanyaan forum 
            <a href="#">{{ itm.target_name }}</a> 
          </div>
          <div v-else>
            {{ itm.user_name }} {{ itm.type }}
          </div>
        </b-dropdown-item>
      </b-dropdown>

      <a href="https://alfathbelajar.com/dashboard/editprofile" v-if="checkPage">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="user-cog" class="mr-1"></fa-icon>
        </my-button>
      </a>
    </div>

    <div class="my-navbar__right sm-show">
      <a class="mr-2" :href="'https://alfathbelajar.com/subject' + (section.subject_id ? ('/'+section.subject_id) : '')"  v-if="checkPage">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="home" class="mr-1"></fa-icon>
        </my-button>
      </a>
      <a class="mr-2" :href="'https://alfathbelajar.com/tryoutlist'"  v-if="tryoutPage">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="home" class="mr-1"></fa-icon>
        </my-button>
      </a>
      <my-button style="padding: 0 11px 0 15px;" v-if="tryoutPage" @click="goToTryoutHistory">
        <fa-icon icon="clock" class="mr-1"></fa-icon>
      </my-button>
      <my-button class="mr-2" type="fill-blue" v-if="isLoggedIn && checkPage" @click="goToForum" style="padding: 0 11px 0 15px;">
        <fa-icon icon="comment-dots" class="mr-1"></fa-icon>
      </my-button>
      <b-dropdown text="Notification" class="my-dropdown mr-2" v-if="checkPage">
        <template #button-content>
          <fa-icon icon="bell" class="mr-1"></fa-icon> 
          <b-badge variant="danger" v-if="unread">{{unread}}</b-badge>
        </template>
        <b-dropdown-item @click="goToNotif()" class="text-center">
          <a href="#">See All Notification</a>
        </b-dropdown-item>
        <b-dropdown-item v-for="(itm, idx) in notifs" @click="goToForumDetail(itm)" :key="'b-'+idx">
          <div class="aspace-between mb-2">
            <img src="/img/avatars/user-avatar4.png" alt="avatar" width="30"/>
            <span class="discussion__time">
              <b>{{ itm.user_name }}</b>
            </span>
            <span class="discussion__time">
              {{ $helpers.formatDateTimeID(itm.created_at) }}
            </span>
          </div>
          <div v-if="itm.type=='forum_reply'">
            <a href="#">{{ itm.user_name }}</a> 
            menjawab pertanyaan forum 
            <a href="#">{{ itm.target_name }}</a> 
          </div>
          <div v-else>
            {{ itm.user_name }} {{ itm.type }}
          </div>
        </b-dropdown-item>
      </b-dropdown>
      <a href="https://alfathbelajar.com/dashboard/editprofile" v-if="checkPage">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="user-cog" class="mr-1"></fa-icon>
        </my-button>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";
import { DB } from '@/helpers/fireinit';

export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notifs: [], 
      unread: 0,
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN, 
      user: types.USER,
      section: types.SECTION
    }), 
    checkPage() {
      if(this.$route.name) {
        return this.$route.name.startsWith('class') || this.$route.name.startsWith('notif') || this.$route.name.startsWith('forum')
      } else {
        return false
      }
    },
    tryoutPage() {
      if(this.$route.name) {
        return this.$route.name.startsWith('tryout')
      } else {
        return false
      }
    }
  },
  mounted() {
    var that = this
    var d = new Date()
    DB.ref('notif-user/'+this.user.id).off()
    DB.ref('notif-user/'+this.user.id).orderByChild("created_at").startAt(d.toISOString()).on("child_added", function(snapshot) {
      var newNotif = snapshot.val();
      if(that.$route.name == 'notif') {
        that.updateNotif(1)
      }
      that.unread++
      that.getNotifList()
      that.$bvToast.toast('Ada jawaban baru di forum ' + newNotif.target_name, {
        title: 'Jawaban Baru',
        autoHideDelay: 3000, 
        toaster: 'b-toaster-top-right',
        variant: 'success'
      })
    });
    this.getNotifList()
    this.getUnred()
  },
  methods: {
    ...mapActions({
      notifList: types.NOTIF_LIST,
      notifUnread: types.NOTIF_UNREAD,
      updateNotif: types.UPDATE_NOTIF,
      logout: types.LOGOUT
    }),
    getNotifList() {
      var payload = {
        params: { 
          limit: 10, 
          offset: 0
        }
      }
      this.notifList(payload)
      .then((response) => {
        this.notifs = response
      })
      .catch((error) => {

      });
    },
    getUnred() {
      this.notifUnread()
      .then((response) => {
        this.unread = response[0].count
      })
      .catch((error) => {

      });
    },
    goLogout() {
      this.logout()
    }, 
    goToForum() {
      this.$router.push('/class/'+this.section.id+'/forum')
    },
    goToForumDetail(item) {
      this.$router.push('/forum/'+item.target_id)
    }, 
    goToNotif() {
      this.$router.push('/notif')
    }, 
    goToTryoutHistory() {
      this.$router.push('/tryout-history')
    }
  }
};
</script>

<style>

@media only screen and (max-width: 768px) {
  .my-navbar__right.sm-show {
    display: flex;
  }
}

.my-dropdown .btn {
  height: 35.3px;
  border-radius: 5px;
  border: solid 1px #009feb;
  background-color: #ffffff;
  font-size: 11px;
  color: #009feb;
  padding: 0 10px;
  font-weight: bold;
}

.my-dropdown.show > .btn.btn-secondary.dropdown-toggle, 
.my-dropdown .btn:hover {
  background-color: #009feb;
  color: #fff;
}

.my-dropdown .dropdown-toggle::after {
  display: none;
}

.my-dropdown .dropdown-menu {
  padding-top: 0;
  padding-bottom: 0;
}

.my-dropdown .dropdown-item {
  font-size: 12px;
  padding: 10px 20px;
  min-width: 300px;
  border-bottom: 1px solid grey;
}

.my-navbar {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 0 26px;
  min-height: 72px;
}

.my-navbar__right {
  min-height: 72px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.my-navbar__logos {
  width: 88px;
}
</style>
